/**
 * @generated SignedSource<<da3c546a6065348f0702355662e08c71>>
 * @relayHash 719a56f07b0b82e8ee48e81385d03fc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6db9b10d3ed509aef6ef7c393be88c65c654b3297bb62d206dbcfcdc093e8f08

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CardCoverManagerQuery } from './CardCoverManagerQuery.graphql';

const node: PreloadableConcreteRequest<CardCoverManagerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6db9b10d3ed509aef6ef7c393be88c65c654b3297bb62d206dbcfcdc093e8f08",
    "metadata": {},
    "name": "CardCoverManagerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
